<template>
  <div class="feature-card">
    <div class="feature-card__title-row">
      <p class="feature-card__name">{{ productFeatureNameWrapper(product, productFeature) }}</p>
      <button
          type="button"
          class="feature-card__delete"
          v-if="!isCheckbox"
          @click="removeFeatureProduct()">
        <b-icon-trash/>
      </button>
    </div>

    <div class="feature-card__grid" :class="{ 'feature-card__grid--full': isCheckbox }">
      <div class="feature-card__media" v-if="!isCheckbox">
        <input
            :id="featureImageInputId"
            ref="featureImageInput"
            type="file"
            accept="image/*"
            class="feature-card__file-input"
            @change="onFileChange"/>

        <div
            class="feature-card__image-wrap"
            role="button"
            tabindex="0"
            title="کلیک برای انتخاب عکس"
            @click="openImagePicker"
            @keyup.enter="openImagePicker">
          <img
              alt=""
              class="feature-card__image"
              :src="setFeatureImage"/>
          <span class="feature-card__image-hint">
            <b-icon icon="camera"/>
            انتخاب عکس
          </span>
          <feature-remove-image-button
              v-if="hasFeatureImage"
              :product-feature="productFeature"
              class="feature-card__remove-image"/>
        </div>
      </div>

      <div class="feature-card__fields" :class="{ 'feature-card__fields--with-extra': productFeature.variation == 1 }">
        <template v-if="productFeature.variation == 1">
          <div class="feature-card__field">
            <label :for="`feature-price-${productFeature.id}`">قیمت</label>
            <input
                type="text"
                v-model="productFeature.price"
                class="form-control"
                :id="`feature-price-${productFeature.id}`">
            <span class="feature-card__preview" v-if="productFeature.price">{{ formatNumber(productFeature.price) }}</span>
          </div>
          <div class="feature-card__field">
            <label :for="`feature-offer-${productFeature.id}`">تخفیف</label>
            <input
                type="text"
                v-model="productFeature.offer"
                class="form-control"
                :id="`feature-offer-${productFeature.id}`">
            <span class="feature-card__preview" v-if="productFeature.offer">{{ formatNumber(productFeature.offer) }}</span>
          </div>
          <div class="feature-card__field">
            <label :for="`feature-quantity-${productFeature.id}`">تعداد</label>
            <input
                type="text"
                v-model="productFeature.quantity"
                class="form-control"
                :id="`feature-quantity-${productFeature.id}`">
            <span class="feature-card__preview" v-if="productFeature.quantity">{{ formatNumber(productFeature.quantity) }}</span>
          </div>
          <div class="feature-card__field feature-card__field--extra">
            <feature-item-extra :product="product" :product-feature="productFeature"/>
          </div>
        </template>
        <template v-else>
          <normal-item-config :product="product" :feature-product="productFeature"/>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {defaultProductImage} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import NormalItemConfig from "./NormalItemConfig.vue";
import FeatureItemExtra from "./FeatureItemExtra.vue";
import FeatureRemoveImageButton from "./FeatureRemoveImageButton.vue";
import {productFeatureName, checkValueIsNumber} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product'
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "ProductFeatureItem",
  components: {FeatureRemoveImageButton, FeatureItemExtra, NormalItemConfig},
  props: {
    productFeature: {},
    product: {},
  },
  data() {
    return {
      defaultProductImage
    }
  },
  computed: {
    feature() {
      return this.productFeature.feature
    },
    productFeatures() {
      return this.product.features
    },
    featureImageInputId() {
      return `feature-product-image-${this.productFeature.id}`
    },
    hasFeatureImage() {
      return !!(this.productFeature.preview || this.productFeature.image)
    },
    setFeatureImage() {
      let preview = this.productFeature.preview
      let featureImage = this.productFeature.image;
      let defaultImage = this.defaultProductImage

      if (preview != null) {
        return preview
      }

      if (featureImage == null) {
        return defaultImage
      }
      return featureImage
    },
    isCheckbox() {
      return Array.isArray(this.productFeature)
    }
  },
  methods: {
    formatNumber,
    checkValueIsNumber,
    productFeatureName,
    openImagePicker() {
      if (this.$refs.featureImageInput) {
        this.$refs.featureImageInput.click()
      }
    },
    removeItemInFront(feature) {
      this.product.features.forEach((item, index) => {
        if (item.id == feature.id) {
          this.product.features.splice(index, 1)
        }
      })
    },
    removeFeatureProduct() {
      const feature = this.productFeature

      if (confirm('آیا از حذف ایتم اطمینان دارید؟')) {

        const form = {
          product_id: feature.product_id,
          feature_product: [feature.id],
        }

        const isItemSavedBefore = this.checkValueIsNumber(feature.id); // we set local item id as hash and cant be parse to int
        if (isItemSavedBefore) {
          this.$store.dispatch('Product/deleteProductFeature', form).then(res => {
            this.removeItemInFront(feature)
          })
        } else {
          this.removeItemInFront(feature)
        }


      }

    },
    onFileChange(e) {
      const file = e.target.files[0];
      if (!file) return
      this.productFeature.image = file;
      this.productFeature.preview = URL.createObjectURL(file);
    },
    productFeatureNameWrapper(product,featureProduct) {
      return Array.isArray(featureProduct) ? this.productFeatureName(product, featureProduct) : this.productFeatureName(product, featureProduct.id)
    }
  },
}
</script>

<style scoped>
.feature-card {
  padding: 0.9rem;
  border-radius: 14px;
  border: 1px solid rgba(30, 30, 30, 0.1);
  background: #fff;
  box-shadow: 0 6px 18px rgba(30, 30, 30, 0.04);
}

.feature-card__title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.85rem;
}

.feature-card__name {
  margin: 0;
  font-weight: 800;
  color: #1e1e1e;
  line-height: 1.5;
}

.feature-card__delete {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(220, 37, 48, 0.18);
  border-radius: 10px;
  background: rgba(220, 37, 48, 0.08);
  color: #dc2530;
  cursor: pointer;
  flex: 0 0 auto;
}

.feature-card__grid {
  display: grid;
  grid-template-columns: minmax(140px, 180px) minmax(0, 1fr);
  gap: 0.85rem;
  align-items: stretch;
}

.feature-card__grid--full {
  grid-template-columns: 1fr;
}

.feature-card__media {
  min-width: 0;
  height: 100%;
}

.feature-card__file-input {
  display: none;
}

.feature-card__image-wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 168px;
  padding: 0.55rem;
  border-radius: 14px;
  background: #f5f5f6;
  border: 1px dashed rgba(30, 30, 30, 0.14);
  cursor: pointer;
  overflow: hidden;
}

.feature-card__image-wrap:hover .feature-card__image-hint {
  opacity: 1;
}

.feature-card__image {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 140px;
  max-height: 168px;
  object-fit: contain;
  border-radius: 10px;
}

.feature-card__image-hint {
  position: absolute;
  left: 50%;
  bottom: 0.7rem;
  transform: translateX(-50%);
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem 0.7rem;
  border-radius: 999px;
  background: rgba(30, 30, 30, 0.78);
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
  opacity: 0.92;
  pointer-events: none;
  white-space: nowrap;
}

.feature-card__remove-image {
  position: absolute;
  top: 0.55rem;
  left: 0.55rem;
  z-index: 2;
}

.feature-card__fields {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.65rem;
  min-width: 0;
  align-items: stretch;
  align-content: stretch;
  height: 100%;
}

.feature-card__fields--with-extra {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.feature-card__field {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 168px;
  height: 100%;
  padding: 0.65rem;
  border-radius: 12px;
  background: #f7f7f8;
  border: 1px solid rgba(30, 30, 30, 0.08);
}

.feature-card__field--extra {
  padding: 0;
  background: transparent;
  border: 0;
  grid-column: 1 / -1;
  align-items: stretch;
  min-height: 168px;
}

.feature-card__field--extra >>> .feature-extra,
.feature-card__field--extra >>> .feature-extra__tile {
  height: 100%;
  min-height: 168px;
}

.feature-card__field label {
  display: block;
  width: 100%;
  margin-bottom: 0.35rem;
  font-size: 0.82rem;
  font-weight: 700;
  color: #424242;
  text-align: center;
}

.feature-card__field .form-control {
  width: 100%;
  border-radius: 10px;
  border-color: rgba(30, 30, 30, 0.12);
  text-align: center;
}

.feature-card__preview {
  display: block;
  width: 100%;
  margin-top: 0.35rem;
  color: var(--primary, #eb3d60);
  font-size: 0.84rem;
  font-weight: 700;
  direction: ltr;
  text-align: center;
}

@media (min-width: 1200px) {
  .feature-card__fields--with-extra {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .feature-card__field--extra {
    grid-column: auto;
  }
}

@media (max-width: 991.98px) {
  .feature-card__grid {
    grid-template-columns: 1fr;
  }

  .feature-card__fields,
  .feature-card__fields--with-extra {
    grid-template-columns: 1fr;
  }

  .feature-card__field--extra {
    grid-column: auto;
  }
}
</style>
